import { render, staticRenderFns } from "./classCourseDetail.vue?vue&type=template&id=5a159244&scoped=true"
import script from "./classCourseDetail.vue?vue&type=script&lang=js"
export * from "./classCourseDetail.vue?vue&type=script&lang=js"
import style0 from "./classCourseDetail.vue?vue&type=style&index=0&id=5a159244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a159244",
  null
  
)

export default component.exports